import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTakeReward } from '../ducks/quests.duck';

export const useQuestRewardFacade = () => {
  const dispatch = useDispatch();

  const takeRewarHandle = useCallback(
    (id: number) => () => {
      dispatch(fetchTakeReward(id));
    },
    [dispatch]
  );

  return {
    takeRewarHandle,
  };
};
